// Self-hosted IBM Plex Sans Arabic (ADR-026, docs/plan/13-ui-ux.md section 3). The stylesheet is
// imported dynamically and only when Arabic is active, so French and English users never download
// it. The Latin fonts (IBM Plex Sans and Mono) are imported once in main.tsx. Both come from
// @batiflow/ui as same-origin assets: no CDN and no Google Fonts (CSP font-src 'self').
let arabicFonts: Promise<unknown> | undefined;

export function loadArabicFonts(): Promise<unknown> {
  arabicFonts ??= import('@batiflow/ui/fonts/arabic.css').catch(() => {
    // Offline or blocked: the system Arabic font is used instead. Retry on the next call.
    arabicFonts = undefined;
  });
  return arabicFonts;
}
